import * as React from 'react';
import cn from 'clsx';
import { ArticleHeading2, ArticleParagraph1, Image, UIText1 } from '@cian/ui-kit';

import image1x from './assets/about_service_presentation_1x.png';
import image2x from './assets/about_service_presentation_2x.png';
import { withDeviceType, IWithDeviceTypeProps } from '../../utils/withDeviceType';
import { X2_IMAGE_SIZE_MEDIA_QUERY } from '../../constants/mediaQueries';

import * as styles from './styles.css';

interface IAboutServicePresentationSectionProps extends IWithDeviceTypeProps {
  url: string;
  onDownloadClick(): void;
}

/**
 * Секция "Расскажите своим клиентам о сервисе".
 */
const AboutServicePresentationSection: React.FC<React.PropsWithChildren<IAboutServicePresentationSectionProps>> = ({
  deviceType,
  url,
  onDownloadClick,
}) => {
  return (
    <div className={cn(styles['container'], styles[deviceType])}>
      <div className={cn(styles['inner-container'], styles[deviceType])}>
        <div className={cn(styles['description'], styles[deviceType])}>
          <ArticleHeading2 as="h2">Расскажите своим клиентам о сервисе</ArticleHeading2>
          <ArticleParagraph1 as="p">
            Электронная регистрация собственности на Циан доступна только риелторам. Расскажите своим клиентам о сервисе
            и проведите сделку через нас.
          </ArticleParagraph1>
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            onClick={onDownloadClick}
            className={cn(styles['button'], styles[deviceType])}
          >
            <UIText1 fontWeight="bold" color="primary_100">
              Скачать презентацию
            </UIText1>
          </a>
        </div>
        <div className={cn(styles['image'], styles[deviceType])}>
          <div className={cn(styles['image-inner'], styles[deviceType])}>
            <Image
              sources={[{ media: X2_IMAGE_SIZE_MEDIA_QUERY, srcset: image2x }, { srcset: image1x }]}
              src={image1x}
              borderRadius={0}
              display="block"
              objectFit="contain"
              width="100%"
              alt="Презентация сервиса «Циан.Сделка»"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const AboutServicePresentationSectionWithDeviceType = withDeviceType(AboutServicePresentationSection);
export { AboutServicePresentationSectionWithDeviceType as AboutServicePresentationSection };
